import { render } from "./VehicleTypesView.vue?vue&type=template&id=019ae1b6"
import script from "./VehicleTypesView.vue?vue&type=script&lang=js"
export * from "./VehicleTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__